import { render } from "./IconWhatsApp.vue?vue&type=template&id=c33db24a"
import script from "./IconWhatsApp.vue?vue&type=script&lang=js"
export * from "./IconWhatsApp.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__